import React from "react"
import Radium from "radium"

const _blueButton = (disabled) => ({
    cursor: 'pointer',
    display: 'inline-block',
    height:'2em',
    fontSize:'1em',
    lineHeight:'2em',
    outline: 0,
    border: '1px solid #fff',
    verticalAlign: 'baseline',
    backgroundColor: disabled ? '#D3D3D3' : 'transparent',
    color: disabled ? '#a2a2a2' : '#fff',
    fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
    margin: '0 .25em 0 0',
    padding: '0 1.5em',
    textTransform: 'none',
    textShadow: 'none',
    fontWeight: 400,
    fontStyle: 'normal',
    textAlign: 'center',
    textDecoration: 'none',
    borderRadius: '.28571429rem',
    boxShadow: '0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset',
    transition: 'opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease',
    ':hover':{
        backgroundColor: 'rgba(0,0,0,0.05)',
        boxShadow: '0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset',
        color: '#f2f2f2'
    },
    ':active': {
        backgroundColor: 'rgba(0,0,0,0.1)',
        color: '#f4f4f4'
    },
    float:'center',
    whiteSpace: 'nowrap'

})

const WhiteButtonEditBloc = ({text, style, disabled, onClick }) => {
    return (
        <button style={{..._blueButton(disabled), ...style}} disabled={disabled} onClick={(e) => {e.preventDefault();onClick()}}>{text}</button>
    )
}

export default Radium(WhiteButtonEditBloc)